<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          SPU：{{
            formData.evgSpuNo
              ? formData.evgSpuNo
              : $l('title_status_created') || '新增'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.evgSpuStatus === 'Y'
              ? 'success'
              : formData.evgSpuStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_evgSpuStatus || $l('title_status_planning') || '企划' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="spuForm" size="mini" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <div @click="onImagePreview" class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="scale-down"
            :src="formData.defaultImageUrl"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>
        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_goodsNameCn') || '中文名称'"
                prop="goodsName"
              >
                <el-input
                  v-model="formData.goodsName"
                  :placeholder="
                    $l('tips_input_goodsNameCn_placeholder') || '请输入...'
                  "
                  clearable
                  maxlength="100"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('form_label_goodsNameEn') || '英文名称'
                "
                prop="goodsNameEn"
              >
                <el-input
                  v-model="formData.goodsNameEn"
                  :placeholder="
                    $l('tips_input_goodsNameEn_placeholder') || '请输入...'
                  "
                  clearable
                  maxlength="100"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_cust') || '客户'"
                prop="custCode"
              >
                <dict-select
                  v-model="formData.custCode"
                  url="/ecom/ecom/evg/spu/customerFormalSelect"
                  :placeholder="
                    $l('form_label_cust_placeholder') || '请选择客户'
                  "
                  :disabled="disabled"
                  @change="changeCustCode"
                  filterable
                  clearable
                  size="mini"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <el-select
                  v-model="formData.brandCode"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="disabled"
                  @change="onChangeBrand"
                  :placeholder="$l('tips_select_brand_data') || '请选择...'"
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_category') || '分类'"
                prop="categoryCode"
              >
                <CategoryCascader
                  :categoryCode.sync="formData.categoryCode"
                  :categoryName.sync="formData.categoryName"
                  :masterCategoryCode.sync="formData.masterCategoryCode"
                  :masterCategoryName.sync="formData.masterCategoryName"
                  :displayCategoryCode.sync="formData.displayCategoryCode"
                  :displayCategoryName.sync="formData.displayCategoryName"
                  :disabled="disabled"
                  @change="clearCollection"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <br />
          <el-button
            type="primary"
            style="width:130px"
            plain
            :disabled="['changeName', 'add'].includes(optType)"
            @click="spuImageVisible = true"
          >
            {{ $l('form_label_picture_maintenance') || '图片维护' }}
          </el-button>
        </el-form-item>
        <el-col :span="22">
          <el-row :gutter="10" type="flex" justify="end">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_succession') || '系列'"
                prop="collectionName"
              >
                <el-input
                  v-model="formData.collectionName"
                  :disabled="disabled"
                  readonly
                >
                  <el-button
                    slot="append"
                    v-if="showChooseCollection"
                    icon="el-icon-more"
                    :disabled="disabled"
                    @click="openChooseCollection"
                  />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16"> </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="d-flex justify-content-end">
        <el-button
          v-if="!showChangeButton"
          type="primary"
          size="small"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
        <el-button
          v-if="showChangeButton"
          type="primary"
          size="small"
          @click="changeName()"
        >
          {{ $l('btn_change_name') || '变更名称' }}
        </el-button>
      </div>
    </el-form>

    <SpuImage
      v-if="spuImageVisible"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
      :visible.sync="spuImageVisible"
      :evgSpuCode="evgSpuCode"
      @reload="getData"
    />

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <ChooseCollection
      v-if="chooseCollectionVisible"
      :visible.sync="chooseCollectionVisible"
      :title="$l('dialog_title_choose_collection') || '系列选择'"
      :form="formData"
      @confirm="updateCollection"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

import CategoryCascader from '../category-cascader'
import SpuImage from './spu-image'
import ChooseCollection from './choose-collection'
export default {
  mixins: [EditLoading],
  components: { CategoryCascader, SpuImage, ChooseCollection },
  props: {
    evgSpuCode: { type: String, default: '' },
    evgSpuStatus: { type: String, default: '' },
    optType: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        goodsName: [
          {
            required: true,
            message: this.$l('tips_input_goodsNameCn_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message: this.$l('tips_input_goodsNameEn_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              if (!reg.test(value)) {
                callback()
              } else {
                callback(
                  new Error(
                    this.$l('form_placeholder_goodsNameEn_noChina') ||
                      '英文名称不能存在中文'
                  )
                )
              }
            },
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('form_label_select_custCode') || '请选择...',
            trigger: 'change',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('tips_select_brand_data') || '请选择...',
            trigger: 'change',
          },
        ],
        collectionName: [
          {
            required: true,
            message: this.$l('form_label_selectseries') || '请选择...',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('form_label_select_categoryCode') || '请选择...',
            trigger: 'change',
          },
        ],
      },
      brandOptions: [],
      seriesCustCodes: [],
      spuImageVisible: false,
      chooseCollectionVisible: false,
    }
  },
  computed: {
    disabled() {
      return ['changeName'].includes(this.optType)
    },
    showChangeButton() {
      return ['changeName'].includes(this.optType)
    },
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
    showChooseCollection() {
      return this.seriesCustCodes.includes(this.formData.custCode)
    },
    brandOptionsMap() {
      return Object.fromEntries(this.brandOptions.map((o) => [o.value, o]))
    },
  },
  async mounted() {
    await this.getSeriesCustCodes()
    await this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getSeriesCustCodes() {
      const res = await this.$api
        .SYS_PARAMS_DETAIL({ paramID: 'SeriesCustCodes' })
        .catch(() => null)
      const { paramValue } = res?.body || {}
      this.seriesCustCodes = JSON.parse(paramValue || '[]')
    },
    async getData() {
      if (!this.evgSpuCode) return
      const res = await this.$api
        .ecomEvgSpuDetailApi({
          evgSpuCode: this.evgSpuCode,
        })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = { ...data }
      const { evgSpuStatus } = data
      this.getBrandInfo()
      this.$emit('update:evgSpuStatus', evgSpuStatus)
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer

      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    async save() {
      const result = await validate.formValidate([this.$refs.spuForm])
      if (!result) return
      this.loadingOpen()
      const res = await this.$api
        .ecomEvgSpuSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_save_spu_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_save_spu_ok') || '保存成功！',
        type: 'success',
      })

      const { evgSpuCode = '', evgSpuNo = '' } = body || {}
      if (this.optType === 'add' && evgSpuCode) {
        this.$router.replace({
          name: 'ecom-base-evgspu-detail',
          params: { evgSpuCode, pageType: 'edit' },
          query: { evgSpuNo },
        })
        return
      }
      await this.getData()
    },
    openChooseCollection() {
      const { brandCode, categoryCode } = this.formData
      if (!brandCode || !categoryCode) {
        this.$message({
          message: this.$l('tips_pl_select_brand_category') ||'请先选择品牌、品类',
          type: 'warning',
        })
        return
      }
      this.chooseCollectionVisible = true
    },
    async changeName() {
      const result = await validate.formValidate([this.$refs.spuForm])
      if (!result) return

      const { evgSpuCode, goodsName, goodsNameEn } = this.formData

      this.loadingOpen()
      const res = await this.$api
        .ecomEvgSpuChangeNameApi({ evgSpuCode, goodsName, goodsNameEn })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_change_failure') || '变更失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_change_success') || '变更成功！',
        type: 'success',
      })
      this.$emit('reload')
      await this.getData()
    },
    changeCustCode() {
      this.brandOptions = []
      if (
        this.seriesCustCodes.includes(this.formData.custCode) ||
        !this.formData.custCode
      ) {
        this.formData = {
          ...this.formData,
          collectionNo: '',
          collectionName: '',
          brandName: '',
          brandCode: '',
        }
      } else {
        this.formData = {
          ...this.formData,
          collectionNo: 'N/A',
          collectionName: 'N/A',
          brandName: '',
          brandCode: '',
        }
      }

      this.getBrandInfo()
    },
    getBrandInfo() {
      this.brandOptions = []
      if (this.formData.custCode) {
        this.$api
          .ecomEvgSpuCustBrandSelectApi({
            custCode: this.formData.custCode,
          })
          .then((res) => {
            this.brandOptions = res?.body?.data || []
          })
      }
    },
    updateCollection(data) {
      this.$refs.spuForm.clearValidate('collectionName')
      const { value = '', label = '' } = data
      this.formData = {
        ...this.formData,
        collectionNo: value,
        collectionName: label,
      }
    },
    onChangeBrand(val) {
      if (val) {
        this.formData.brandName = this.brandOptionsMap[val].label
      }
      if (this.seriesCustCodes.includes(val)) {
        this.formData.collectionNo = ''
        this.formData.collectionName = ''
      }
    },
    clearCollection() {
      if (this.seriesCustCodes.includes(this.formData.custCode)) {
        this.formData.collectionNo = ''
        this.formData.collectionName = ''
      }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
